import { RequestPolicy } from 'urql';

import { useBagCountQuery } from './GraphQL/BagCount.generated';

/**
 * Returns the current bag count from the cache.
 */
export const useBagCount = (params: BagCountParams = {}) => {
  const { requestPolicy = 'cache-only', pause = false } = params;

  const [response] = useBagCountQuery({ requestPolicy, pause });

  const lineItems = response.data?.cart?.lineItems ?? [];
  const bagCount = lineItems.reduce((total, item) => total + (item.quantity || 1), 0);

  const isLoadingBagCount = response.fetching;

  return { bagCount, isLoadingBagCount };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type BagCountParams = {
  requestPolicy?: RequestPolicy;
  pause?: boolean;
};
